export default {
  columns: {
    version: 'Versie',
    signed_at: 'Ondertekend op',
    internal_note: 'Interne notitie',
    signature_provider: 'Handtekeningprovider',
    file: 'Document',
    actions: 'Acties',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Nog geen handtekeninggeschiedenis beschikbaar',
    providers: {
      selfhosted: 'Zelfgehost',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Voorbeeld',
    download: 'Downloaden',
  },
};
